import { render, staticRenderFns } from "./correct.vue?vue&type=template&id=26cfce56&scoped=true"
import script from "./correct.vue?vue&type=script&lang=js"
export * from "./correct.vue?vue&type=script&lang=js"
import style0 from "./correct.vue?vue&type=style&index=0&id=26cfce56&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cfce56",
  null
  
)

export default component.exports